import { createSlotRecipe } from './runtime.js';

const errorStateConfig = {"name":"errorState","slots":["root","content","icon","message","link"]}

export const errorState = /* @__PURE__ */ createSlotRecipe(errorStateConfig)